<template>
  <RecycoGenericInputComponent :label="label" :icon="icon" :validate="validate" :value="value">
    <VSelect :value="value" :label="nameKey" @input="input" v-bind="$attrs" />
  </RecycoGenericInputComponent>
</template>

<script>
  import VSelect from 'vue-select';

  import RecycoGenericInputComponent from './RecycoGenericInputComponent.vue';

  export default {
    name: 'recyco-select',
    components: {
      VSelect,
      RecycoGenericInputComponent,
    },
    props: {
      label: {
        type: String,
        required: true,
      },
      icon: {
        type: String,
      },
      validate: {
        type: Function,
        default: () => null,
      },
      value: {
        default: undefined,
      },
      nameKey: {
        type: String,
      },
    },
    methods: {
      input(value) {
        this.$emit('input', value);
      },
    },
  };
</script>

<style lang="scss">
  @import '~vue-select/src/scss/vue-select.scss';
</style>
